import SettingsModel from './settings.js'

export default {
  get_notifier(value) {
    return _.find(this.notifiers, (notifier) => { return notifier.value == value; });
  },
  notifiers: [
    {name: "Elisa Viihde", value: "ElisaViihde", cms_types: [

    ]},
    {name: "Kepit Event", value: "KepitEvent", cms_types: [
      {name: "Customer", value: "customer"},
      {name: "Image", value: "image"}
    ]},
    {name: "EPG", value: "EPG", cms_types: [

    ]},
    {name: "Sanoma Event", value: "SanomaEvent", cms_types: []},
  ],
  get_cms_types(notifier) {
    return notifier.cms_types;
  }
}
